import { render, staticRenderFns } from "./ChevronHeading.vue?vue&type=template&id=d193e3f0&scoped=true&"
import script from "./ChevronHeading.vue?vue&type=script&lang=js&"
export * from "./ChevronHeading.vue?vue&type=script&lang=js&"
import style0 from "./ChevronHeading.vue?vue&type=style&index=0&id=d193e3f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d193e3f0",
  null
  
)

export default component.exports